/* Fly-to-cart: the garment photo glides in an arc into the header cart button.
   WAAPI-only (no React state) so it stays at 60fps. Disabled for reduced motion. */
export function flyToCart(sourceEl) {
  if (!sourceEl || typeof document === "undefined") return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const target = document.querySelector('[data-testid="cart-open-button"]');
  if (!target) return;
  const s = sourceEl.getBoundingClientRect();
  const tr = target.getBoundingClientRect();
  if (!s.width || !s.height) return;

  const ghost = sourceEl.cloneNode();
  Object.assign(ghost.style, {
    position: "fixed", left: `${s.left}px`, top: `${s.top}px`,
    width: `${s.width}px`, height: `${s.height}px`,
    objectFit: "cover", zIndex: 120, pointerEvents: "none", margin: 0,
    boxShadow: "0 18px 40px -12px rgba(20,24,20,0.45)",
  });
  document.body.appendChild(ghost);

  const dx = tr.left + tr.width / 2 - (s.left + s.width / 2);
  const dy = tr.top + tr.height / 2 - (s.top + s.height / 2);

  const anim = ghost.animate(
    [
      { transform: "translate(0px, 0px) rotate(0deg) scale(1)", opacity: 1 },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 70}px) rotate(-9deg) scale(0.45)`, opacity: 0.95, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) rotate(-16deg) scale(0.07)`, opacity: 0.35 },
    ],
    { duration: 750, easing: "cubic-bezier(0.22, 1, 0.36, 1)" }
  );
  anim.onfinish = () => {
    ghost.remove();
    target.animate(
      [{ transform: "scale(1)" }, { transform: "scale(1.18)" }, { transform: "scale(1)" }],
      { duration: 320, easing: "ease-out" }
    );
  };
}
